module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0101.png.8e06a08f.jpg";